/* eslint-disable import/no-named-as-default-member */
import {
  ArrowRightIcon,
  DragDrop,
  FormControlLabel,
  GKButton,
  GKCheckbox,
  GKModal,
  GKRadio,
  GKSearchSelect,
  GKSelect,
  Grid2,
  MenuItem,
  RadioGroup,
  RedirectIcon,
  Show,
  Typography,
  ViewPdf,
} from "components";
import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import {
  CUSTOM_AGREEMENT_MODAL_PORTFOLIO,
  GET_ALL_AGREEMENT,
  GET_ALL_FEE_PLAN,
} from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { GKModalProps } from "utils/commonInterface";
import { AGREEMENT_SIGNATURE_SOURCE } from "utils/constants";
import { refetchQuery } from "utils/helpers";

interface Props {
  id: string;
  type: string;
}

const ClientCustomAgreement = (props: Props & GKModalProps) => {
  const { setOpen, open, id, type = null } = props;

  const [viewPdf, setViewPdf] = useState(false);

  const [pdfMode, setPdfMode] = useState<"preview" | "send">("preview");

  const [uploadError, setUploadError] = useState<string | null>(null);

  const { data } = useFetchQuery({
    key: ["GET_ALL_CUSTOM_AGREEMENTS"],
    route: GET_ALL_AGREEMENT,
  });

  const { data: feePlanDropdownData } = useFetchQuery({
    key: ["GET_ALL_FEE_PLAN"],
    route: GET_ALL_FEE_PLAN,
  });

  const { data: equityBasketData } = useFetchQuery({
    key: ["GET_ALL_EQUITY_BASKET"],
    route: CUSTOM_AGREEMENT_MODAL_PORTFOLIO,
  });

  const form = useForm({
    defaultValues: {
      document: [],
      signatureType: "",
      sendOptions: "Mobile",
      sendOptionss: "GA",
      template: "",
      selectedTemplate: null,
      generateResponse: null,
      feePlan: "",
      equityBasket: "",
      manual: false,
    },
  });

  form.watch();

  const { mutate: handleUploadAgreement, isLoading } = useMutation({
    mutationKey: ["CLIENT_ONBOARDING_CUSTOM_AGREEMENT"],
    mutationFn: (data: any) => axiosInstance.post(`/agreements/${id}/`, data),
    onSuccess: () => {
      refetchQuery("GET_ALL_COMPLIANCE_BY_CLIENT_ID");
      setOpen(false);
    },
  });

  const { mutate: handleUploadManualAgreement, isLoading: manualLoading } =
    useMutation({
      mutationKey: ["UPLOAD_AGREEMENT_MANUAL"],
      mutationFn: (data: any) =>
        axiosInstance.post(`/agreements/${id}/?manual=true`, data),
      onSuccess: () => {
        refetchQuery("GET_ALL_COMPLIANCE_BY_CLIENT_ID");
        setOpen(false);
      },
    });

  const { mutate: handleGenerateAgreement, isLoading: generateLoading } =
    useMutation({
      mutationKey: ["GENERATE_AGREEMENT"],
      mutationFn: (data: any) =>
        axiosInstance.post(`/custom-agreement/${id}/generate-agreement/`, data),
      onSuccess: (response: any) => {
        form.setValue("generateResponse", response?.data?.data);
        // toast.success(
        //   response?.data?.message || "Agreement generated successfully",
        // );
        setViewPdf(false);
      },
    });

  const selectedOption = form.watch("sendOptionss");

  return (
    <GKModal
      width={"450px"}
      maxHeight="auto"
      open={open}
      setOpen={setOpen}
      modalTitle={"Request Sign"}
      footer={
        selectedOption === "GA" ? (
          <Grid2 container justifyContent={"flex-end"} gap={1} mt={1}>
            <Show.When isTrue={Boolean(form.getValues("generateResponse"))}>
              <GKButton
                variant="outlined"
                size="medium"
                color="dark"
                sx={{ width: "205px" }}
                loading={generateLoading}
                startIcon={<RedirectIcon />}
                onClick={() => {
                  setViewPdf(true);
                  setPdfMode("preview");
                }}
              >
                Preview Agreement
              </GKButton>
            </Show.When>
            <GKButton
              sx={{ ml: "auto", width: "205px" }}
              variant="contained"
              size="medium"
              loading={generateLoading}
              endIcon={<ArrowRightIcon />}
              onClick={() => {
                if (form.getValues("generateResponse")) {
                  setPdfMode("send");
                  setViewPdf(true);
                } else {
                  handleGenerateAgreement({
                    [type]: id,
                    template: form.getValues("template"),
                    feePlan: form.getValues("feePlan"),
                    modelPortfolio: form.getValues("equityBasket"),
                  });
                }
              }}
            >
              {form.getValues("generateResponse")
                ? "Generate & Preview"
                : "Generate Agreement"}
            </GKButton>
          </Grid2>
        ) : selectedOption === "UA" ? (
          <GKButton
            type="submit"
            variant="contained"
            form="agreement-form"
            size="medium"
            sx={{ width: "418px" }}
            loading={isLoading || manualLoading}
            startIcon={<ArrowRightIcon />}
          >
            Submit
          </GKButton>
        ) : null
      }
    >
      <form
        id="agreement-form"
        onSubmit={form.handleSubmit((values) => {
          if (selectedOption === "UA") {
            if (values.manual) {
              const formData = new FormData();
              formData.append("document", values.document[0]);
              formData.append(type, id);
              handleUploadManualAgreement(formData);
            } else {
              const fileData = new FormData();
              fileData.append("document", values.document[0]);
              fileData.append("sendOptions", values.sendOptions);
              fileData.append("signatureType", values.signatureType);
              fileData.append(type, id);
              handleUploadAgreement(fileData);
            }
          } else {
            const fileData = new FormData();
            fileData.append("sendOptions", values.sendOptions);
            fileData.append("signatureType", values.signatureType);
            fileData.append(type, id);
            fileData.append("template", values.template);
            handleUploadAgreement(fileData);
          }
        })}
      >
        <Grid2 container spacing={2}>
          <Grid2 size={12}>
            <Typography fontSize={13} fontWeight={600} color="var(--black-900)">
              Select method to request agreement:
            </Typography>
            <Grid2 display="flex" gap={1} mt={1}>
              <Controller
                name="sendOptionss"
                control={form.control}
                render={({ field }) => (
                  <RadioGroup
                    {...field}
                    value={field.value || "GA"}
                    onChange={(e) => field.onChange(e.target.value)}
                    sx={{ display: "flex", flexDirection: "row", gap: 0.5 }}
                  >
                    <FormControlLabel
                      value="GA"
                      control={<GKRadio />}
                      label="Generate Agreement"
                    />
                    <FormControlLabel
                      value="UA"
                      control={<GKRadio />}
                      label="Upload Agreement"
                    />
                  </RadioGroup>
                )}
              />
            </Grid2>
          </Grid2>

          {selectedOption === "GA" && (
            <>
              <Grid2 size={12}>
                <Controller
                  name="template"
                  control={form.control}
                  render={({ field }) => (
                    <GKSelect
                      {...field}
                      inputLabel={"Template"}
                      onChange={(e) => {
                        field.onChange(e);
                        form.setValue(
                          "selectedTemplate",
                          data?.data?.data?.find(
                            (d: any) => d.id === e.target.value,
                          ),
                        );
                        form.setValue("generateResponse", null);
                      }}
                    >
                      <MenuItem style={{ display: "none" }} value="">
                        Select Template
                      </MenuItem>
                      {data?.data?.data?.length === 0 ? (
                        <MenuItem value={"no-data"} disabled>
                          No data found
                        </MenuItem>
                      ) : (
                        data?.data?.data?.map((dataItem: any, i: any) => (
                          <MenuItem key={i} value={dataItem.id}>
                            {dataItem.title}
                          </MenuItem>
                        ))
                      )}
                    </GKSelect>
                  )}
                />
              </Grid2>
              <Show.When
                isTrue={form.getValues("selectedTemplate")?.isModelPortfolio}
              >
                <Grid2 size={12}>
                  <Controller
                    name="equityBasket"
                    control={form.control}
                    render={({ field }) => (
                      <GKSearchSelect
                        inputLabel="Equity Basket"
                        options={equityBasketData?.data?.data || []}
                        getOptionLabel={(opt) => opt?.name || opt}
                        onChange={(event, val) => {
                          field.onChange(val.id);
                        }}
                        value={
                          equityBasketData?.data?.data?.find(
                            (item: any) => item?.id === field?.value,
                          )?.name
                        }
                      />
                    )}
                  />
                </Grid2>
              </Show.When>
              <Show.When isTrue={form.getValues("selectedTemplate")?.isFeePlan}>
                <Grid2 size={12}>
                  <Controller
                    name="feePlan"
                    control={form.control}
                    render={({ field }) => (
                      <GKSearchSelect
                        options={feePlanDropdownData?.data?.data || []}
                        getOptionLabel={(opt) => opt?.name || opt}
                        inputLabel="Fee Plan"
                        onChange={(event, val) => {
                          field.onChange(val?.value);
                        }}
                        value={
                          feePlanDropdownData?.data?.data?.find(
                            (item: any) => item?.value === field?.value,
                          )?.name
                        }
                      />
                    )}
                  />
                </Grid2>
              </Show.When>
              <Grid2 container size={12} spacing={1}>
                <Grid2
                  size={12}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Show.When isTrue={viewPdf}>
                    <Show.When isTrue={viewPdf}>
                      <ViewPdf
                        open={viewPdf}
                        setOpen={setViewPdf}
                        file={form.getValues("generateResponse")?.file}
                        btnName={
                          pdfMode === "send" ? "Send Agreement" : undefined
                        }
                        onSend={
                          pdfMode === "send"
                            ? () => {
                                const formData = new FormData();
                                formData.append(
                                  "sendOptions",
                                  form.getValues("sendOptions"),
                                );
                                formData.append(
                                  "signatureType",
                                  form.getValues("signatureType"),
                                );
                                formData.append(type, id);
                                formData.append(
                                  "template",
                                  form.getValues("template"),
                                );

                                handleUploadAgreement(formData);
                              }
                            : undefined
                        }
                      />
                    </Show.When>
                  </Show.When>
                </Grid2>
                <Show.When isTrue={Boolean(form.getValues("generateResponse"))}>
                  <Grid2 size={12} mb={2}>
                    <Controller
                      name="signatureType"
                      control={form.control}
                      rules={{
                        required: {
                          value: true,
                          message: "Signature Type is required",
                        },
                      }}
                      render={({ field, formState: { errors } }) => (
                        <GKSelect
                          {...field}
                          requiredField
                          inputLabel="Sign Type"
                          error={Boolean(errors.signatureType)}
                          helperText={
                            Boolean(errors.signatureType) &&
                            errors.signatureType?.message
                          }
                        >
                          <MenuItem style={{ display: "none" }} value="">
                            Select Sign Type
                          </MenuItem>
                          {AGREEMENT_SIGNATURE_SOURCE?.map((dataItem, i) => (
                            <MenuItem key={i} value={dataItem.value}>
                              {dataItem.name}
                            </MenuItem>
                          ))}
                        </GKSelect>
                      )}
                    />
                  </Grid2>

                  <Grid2 size={12}>
                    <Typography fontSize={14} fontWeight={500}>
                      Send agreement via{" "}
                    </Typography>
                    <Grid2 display="flex" gap={3}>
                      <Controller
                        name="sendOptions"
                        control={form.control}
                        render={({ field }) => (
                          <RadioGroup
                            {...field}
                            value={field.value || "Mobile"}
                            onChange={(e) => field.onChange(e.target.value)}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 0.5,
                            }}
                          >
                            <FormControlLabel
                              value="Mobile"
                              control={<GKRadio />}
                              label="Mobile"
                            />
                            <FormControlLabel
                              value="Email"
                              control={<GKRadio />}
                              label="Email"
                            />
                          </RadioGroup>
                        )}
                      />
                    </Grid2>
                  </Grid2>
                </Show.When>
              </Grid2>
            </>
          )}

          {selectedOption === "UA" && (
            <>
              <Grid2 size={12}>
                <Controller
                  name="document"
                  control={form.control}
                  rules={{
                    required: {
                      value: true,
                      message: "Please upload a document",
                    },
                  }}
                  render={({ field, formState: { errors } }) => (
                    <DragDrop
                      uploadError={uploadError}
                      setUploadError={setUploadError}
                      {...field}
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      supportName=".png, .jpg, .pdf"
                      acceptType={".pdf,.png,.jpg"}
                      error={Boolean(errors.document)}
                    />
                  )}
                />
              </Grid2>

              <Grid2 container size={12} spacing={1}>
                <Grid2 size={12}>
                  <Controller
                    name="manual"
                    control={form.control}
                    render={({ field }) => (
                      <FormControlLabel
                        {...field}
                        style={{ marginLeft: 0 }}
                        label="Skip Signature"
                        control={
                          <GKCheckbox
                            value={field.value}
                            onChange={(event) =>
                              field.onChange(event.target.checked)
                            }
                          />
                        }
                      />
                    )}
                  />
                </Grid2>

                <Show.When isTrue={!form?.getValues("manual")}>
                  <Grid2 size={12}>
                    <Controller
                      name="signatureType"
                      control={form.control}
                      rules={{
                        required: {
                          value: !form.getValues("manual"),
                          message: "Please select a sign type",
                        },
                      }}
                      render={({ field, formState: { errors } }) => (
                        <GKSelect
                          {...field}
                          requiredField={!form.getValues("manual")}
                          inputLabel="Sign Type"
                          error={Boolean(errors.signatureType)}
                          helperText={
                            Boolean(errors.signatureType) &&
                            errors.signatureType?.message
                          }
                        >
                          <MenuItem style={{ display: "none" }} value="">
                            Select Sign Type
                          </MenuItem>
                          {AGREEMENT_SIGNATURE_SOURCE?.map((dataItem, i) => (
                            <MenuItem key={i} value={dataItem.value}>
                              {dataItem.name}
                            </MenuItem>
                          ))}
                        </GKSelect>
                      )}
                    />
                  </Grid2>
                </Show.When>

                <Show.When isTrue={!form?.getValues("manual")}>
                  <Grid2 size={12} mt={2}>
                    <Typography fontSize={14} fontWeight={500}>
                      Send agreement via{" "}
                    </Typography>
                    <Grid2 display="flex" gap={3} mt={1}>
                      <Controller
                        name="sendOptions"
                        control={form.control}
                        rules={{ required: "Please select an option" }}
                        render={({ field }) => (
                          <RadioGroup
                            {...field}
                            value={field.value}
                            onChange={(e) => field.onChange(e.target.value)}
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                              gap: 0.5,
                            }}
                          >
                            <FormControlLabel
                              value="Mobile"
                              control={<GKRadio />}
                              label="Mobile"
                            />
                            <FormControlLabel
                              value="Email"
                              control={<GKRadio />}
                              label="Email"
                            />
                          </RadioGroup>
                        )}
                      />
                    </Grid2>
                  </Grid2>
                </Show.When>
              </Grid2>
            </>
          )}
        </Grid2>
      </form>
    </GKModal>
  );
};

export default ClientCustomAgreement;
